const $ = window.$;
const swal = window.swal;
const mjml2html = window.mjml2html;

import {
  reset_buttons,
  create_flatpickr,
} from '_form_helpers';

"use strict";

var Vouchers = {
  init: function() {
    var tgt = $( '.voucher_html_preview' )[ 0 ],
        tgt_win,
        renderHTML,
        current_target = $( '.modal-voucher' ),
        sf_lookup_enabled = false;

    create_flatpickr(
      [
        '#valid-from-group',
        '#valid-to-group',
      ]
    );

    if( tgt === undefined ){ return; }
    tgt_win = tgt.contentWindow || tgt.contentDocument.document || tgt.contentDocument;

    $( '.generate-voucher-template' ).on( 'change', e => {
      reset_voucher();
      get_template( $( e.currentTarget ).val() );
    } );

    function get_template( value ) {
      var intended_for_template,
          row,
          contacts_tag,
          form = $( '.modal-voucher form' );

      if ( value ) {
        fetch( '/vouchers/' + value + '/template' )
          .then( result => result.json() )
          .then( result => {
            $( '.modal-voucher' ).find( '.generate-voucher-body' ).show();
            sf_lookup_enabled = result.data.sf_lookup;
            if ( result.data.intended_for ) {
              intended_for_template = current_target.find( '#voucher_intended_for_template' ).text();
              result.data.intended_for.forEach( function( intended_for ) {
                row = intended_for_template.replace( /{{new_id}}/g, intended_for.id )
                              .replace( /{{r_id}}/g, intended_for.intended_for_id )
                              .replace( /{{r_type}}/g, intended_for.intended_for_type );
                current_target.find( '.voucher-intended-for-wrapper' ).append( row );
                current_target
                  .find( '.voucher-intended-for-box' )
                  .append(
                    "<div class='tags actor border rounded d-flex flex-column " + intended_for.intended_for_type + " new'>" +
                      "<span class='d-flex justify-content-between mt-4'>" +
                        "<span class='py-1 px-2 rounded-end who_type_ribbon'>" + intended_for.intended_for_type + "</span>" +
                        "<span class='d-flex'>" +
                          "<span class='d-none ready-to-save svg-icon svg-icon-3 svg-icon-dark ms-2 opacity-50'>" +
                            "<svg class='icon-ready-to-save'><use xlink:href='#icon-ready-to-save'></use></svg>" +
                          "</span>" +
                          "<span class='voucher-actor-remove btn-close pe-pointer ms-2 me-4'></span>" +
                        "</span>" +
                      "</span>" +
                      "<a data-target-domain='" + intended_for.domain + "' data-target-type='" + intended_for.intended_for_type + "' data-target-id='" + intended_for.intended_for_id + "' class='btn btn-sm fw-normal btn-color-gray-800 btn-active-color-primary text-start' href='" + intended_for.path + "'>" + intended_for.value + "</a>" +
                    "</div>"
                  );
              } );
            }

            if ( result.data.allow_user_creation ) {
              current_target
                .find( '.generate-voucher-allow-user-creation' ).show();
            } else {
              current_target
                .find( '.generate-voucher-allow-user-creation' ).hide();
            }

            current_target.on( 'click', '.voucher-intended-for-box .tags .remove', function(){
              var vc = voucher_contacts_tag( true, true, true );
              vc.removeAllTags();
              $( vc.DOM.scope ).parent().find( '.tagify-wrapper' ).empty();
            } );

            contacts_tag = voucher_contacts_tag( false, false, false );
            contacts_tag.settings.validate = ( e ) => validateDomain( contacts_tag, e );
            contacts_tag.on( 'change', e => {
              if ( e.detail.tagify.value >= 0 ) {
                if ( form.hasClass( 'was-validated' ) ) {
                  if ( !$( contacts_tag.DOM.scope ).is( '[readonly]' ) ) {
                    $( contacts_tag.DOM.originalInput )
                      .next( '.invalid-feedback' )
                      .show();
                    $( contacts_tag.DOM.scope ).addClass( 'is-invalid' );
                  }
                }
                $( '.modal-voucher' )
                  .find( '.preview-email' )
                  .addClass( 'disabled' )
                  .attr( 'data-disabled', 'true' );
                $( '.modal-voucher' ).find( '.generate-voucher-send-email' ).prop( 'disabled', true );
              } else {
                $( '.modal-voucher' )
                  .find( '.preview-email' )
                  .removeClass( 'disabled' )
                  .attr( 'data-disabled', 'false' );
                $( contacts_tag.DOM.originalInput )
                  .next( '.invalid-feedback' )
                  .hide();
                $( contacts_tag.DOM.scope ).removeClass( 'is-invalid' );
                $( '.modal-voucher' ).find( '.generate-voucher-send-email' ).prop( 'disabled', false );
              }
            } );

            if ( sf_lookup_enabled ) {
              if ( !result.data.admin ) {
                if ( !( result.data.intended_for.length > 0 ) ) {
                  $( '.modal-voucher' )
                    .find( '.voucher-intended-for-content' ).hide();
                } else {
                  voucher_intended_for_tag( true, false, true );
                }
              } else {
                voucher_intended_for_tag( true, false, true );
              }
              $( '.modal-voucher' )
                .find( '.generate-voucher-salesforce-opportunity-lookup' ).prop( 'checked', true );
              if ( result.data.admin ) {
                $( '.modal-voucher' ).find( '.salesforce-opportunity-lookup' ).show();
              } else {
                $( '.modal-voucher' ).find( '.salesforce-opportunity-lookup' ).hide();
              }
              $( '.modal-voucher' )
                .find(
                  '.generate-voucher-create-custom-url'
                )
                .prop( 'disabled', true );
            } else {
              $( '.modal-voucher' )
                .find( '.generate-voucher-salesforce-opportunity-lookup' ).prop( 'checked', false );
              if ( result.data.admin ) {
                voucher_intended_for_tag( false, false, false );
              } else {
                if ( !( result.data.intended_for.length > 0 ) ) {
                  $( '.modal-voucher' )
                    .find( '.voucher-intended-for-content' ).hide();
                } else {
                  voucher_intended_for_tag( true, false, true );
                }
              }
              $( '.modal-voucher' )
                .find(
                  '.generate-voucher-create-custom-url'
                )
                .prop( 'disabled', false );
            }

            $( '.modal-voucher' )
              .find(
                '.generate-voucher-name'
              )
              .prop( 'disabled', false );

            $( '.modal-voucher' ).find( '.generate-voucher-usage-limit' ).val( result.data.usage_limit );
            $( '.modal-voucher' ).find( '.generate-voucher-per-user-limit' ).val( result.data.per_user_limit );

            if ( result.data.admin ) {
              $( '.modal-voucher' )
                .find(
                  '.generate-voucher-intended-for-option, ' +
                  '.generate-voucher-valid-for-size, ' +
                  '.generate-voucher-valid-for-type, ' +
                  '.generate-voucher-unlimited-usage-limit, ' +
                  '.generate-voucher-unlimited-per-user-limit, ' +
                  '.generate-voucher-usage-limit, ' +
                  '.generate-voucher-per-user-limit'
                )
                .prop( 'disabled', false );

              $( '.modal-voucher' ).find( '.generate-voucher-valid-for-size' ).val( result.data.valid_for[ 1 ] ).trigger( 'change' );
              $( '.modal-voucher' ).find( '.generate-voucher-valid-for-type' ).val( result.data.valid_for[ 0 ] ).trigger( 'change' );

            } else {
              if ( result.data.overwrite_usage_limit ) {
                $( '.modal-voucher' )
                  .find( '.generate-voucher-usage-limit' )
                  .prop( 'disabled', false );
              } else {
                $( '.modal-voucher' )
                  .find( '.generate-voucher-usage-limit' )
                  .prop( 'disabled', true );
              }
              if ( result.data.overwrite_per_user_limit ) {
                $( '.modal-voucher' )
                  .find( '.generate-voucher-per-user-limit' )
                  .prop( 'disabled', false );
              } else {
                $( '.modal-voucher' )
                  .find( '.generate-voucher-per-user-limit' )
                  .prop( 'disabled', true );
              }
              if ( result.data.overwrite_valid_for ) {
                $( '.modal-voucher' )
                  .find(
                    '.generate-voucher-valid-for-size, ' +
                    '.generate-voucher-valid-for-type'
                  )
                  .prop( 'disabled', false );

                $( '.modal-voucher' ).find( '.generate-voucher-valid-for-size' ).val( result.data.valid_for[ 1 ] ).trigger( 'change' );
                $( '.modal-voucher' ).find( '.generate-voucher-valid-for-type' ).val( result.data.valid_for[ 0 ] ).trigger( 'change' );
              } else {
                $( '.modal-voucher' )
                  .find(
                    '.generate-voucher-valid-for-size, ' +
                    '.generate-voucher-valid-for-type'
                  )
                  .prop( 'disabled', true );

                $( '.modal-voucher' )
                  .find( '.generate-voucher-validity' )
                  .hide();
              }

            }

            setup_modal_multistep();
            setup_generate_voucher();
            setup_voucher_preview();
          } )
          .catch( function() {
            reset_voucher();
          } );
      } else {
        reset_voucher();
      }
    }

    function validateDomain( element, tag ) {
      var domains = [],
          tagDomain,
          current_element,
          salesforce_opportunity_lookup = $( '.modal-voucher' ).find( '.generate-voucher-salesforce-opportunity-lookup' ).prop( 'checked' );

      current_element = $( element.DOM.originalInput ).parents( '.modal-voucher' );

      if ( !sf_lookup_enabled || !salesforce_opportunity_lookup ) {
        current_element.find( '.voucher-intended-for-box .tags' ).each( function( i, obj ) {
          domains.push( $( obj ).find( 'a' ).data( 'target-domain' ).split( ',' ) );
        } );
        domains = $.uniqueSort( [].concat.apply( [], domains ) );
      }

      tagDomain = tag.value.split( '@' );

      if ( domains.length === 0 ) {
        tag.color = 'var(--bs-primary)';
        return true;
      } else if ( $.inArray( tagDomain[ 1 ], domains ) > -1 ) {
        tag.color = 'var(--bs-primary)';
        return true;
      } else {
        return false;
      }
    }

    function setup_modal_multistep() {
      if ( sf_lookup_enabled ) {
        setup_salesforce_lookup();
        $( '.modal-voucher' ).find( '.modal-voucher-sf-lookup' ).show();
        $( '.modal-voucher' ).find( '.modal-voucher-page-next-btn' ).show();
        $( '.modal-voucher' ).find( '.modal-voucher-page' ).eq( 0 ).show();
        $( '.modal-voucher' )
          .find( '.modal-voucher-page-next-btn' )
          .on( 'click', function() {
            setup_page_1();
        } );
        $( '.modal-voucher' )
          .find( '.modal-voucher-page-previous-btn' )
          .on( 'click', function() {
            setup_page_2();
        } );
        $( '.modal-voucher' )
          .find( '.generate-voucher-salesforce-opportunity-lookup' )
          .on( 'change', function( e ) {
            reset_salesforce_lookup();
            if ( e.currentTarget.checked ) {
              voucher_intended_for_tag( true, false, true );
              enable_salesforce_lookup();
              $( '.modal-voucher' )
                .find(
                  '.generate-voucher-create-custom-url, ' +
                  '.generate-voucher-allow-user-creation'
                )
                .prop( 'checked', false );
              $( '.modal-voucher' )
                .find( '.generate-voucher-url' )
                .val( '' )
                .prop( 'disabled', true );
              $( '.modal-voucher' )
                .find(
                  '.generate-voucher-create-custom-url, ' +
                  '.generate-voucher-allow-user-creation'
                )
                .prop( 'disabled', true );
            } else {
              voucher_intended_for_tag( false, false, false );
              disable_salesforce_lookup();
              $( '.modal-voucher' )
                .find(
                  '.generate-voucher-create-custom-url'
                )
                .prop( 'disabled', false );
            }
          } );
      } else {
        $( '.modal-voucher' ).find( '.modal-voucher-sf-lookup' ).hide();
        $( '.modal-voucher' ).find( '.generate-voucher-btn' ).show();
        $( '.modal-voucher' ).find( '.modal-voucher-page' ).show();
      }
    }

    function setup_page_1() {
      $( '.modal-voucher' ).find( '.modal-voucher-page' ).eq( 0 ).hide();
      $( '.modal-voucher' ).find( '.modal-voucher-page' ).eq( 1 ).show();

      $( '.modal-voucher' ).find( '.generate-voucher-btn' ).show();
      $( '.modal-voucher' ).find( '.modal-voucher-page-next-btn' ).hide();
      $( '.modal-voucher' ).find( '.modal-voucher-page-previous-btn' ).show();
      $( '.modal-voucher' ).find( '.generate-voucher-template-group' ).hide();
    }

    function setup_page_2() {
      $( '.modal-voucher' ).find( '.modal-voucher-page' ).eq( 1 ).hide();
      $( '.modal-voucher' ).find( '.modal-voucher-page' ).eq( 0 ).show();

      $( '.modal-voucher' ).find( '.generate-voucher-btn' ).hide();
      $( '.modal-voucher' ).find( '.modal-voucher-page-next-btn' ).show();
      $( '.modal-voucher' ).find( '.modal-voucher-page-previous-btn' ).hide();
      $( '.modal-voucher' ).find( '.generate-voucher-template-group' ).show();
    }

    function setup_generate_voucher() {
      $( '.modal-voucher' )
        .find( '.generate-voucher-unlimited-usage-limit' )
        .on( 'change', function( e ) {
          if ( e.currentTarget.checked ) {
            $( '.modal-voucher' )
              .find( '.generate-voucher-usage-limit' )
              .prop( 'type', 'text' )
              .val( 'Unlimited' )
              .prop( 'disabled', true );
            $( '.modal-voucher' )
              .find( '.generate-voucher-usage-limit' ).hide()
              .parent().find( '.form-text' ).hide();
          } else {
            $( '.modal-voucher' )
              .find( '.generate-voucher-usage-limit' )
              .prop( 'type', 'number' )
              .val( '' )
              .prop( 'disabled', false );
            $( '.modal-voucher' )
              .find( '.generate-voucher-usage-limit' ).show()
              .parent().find( '.form-text' ).show();
          }
        } );

      $( '.modal-voucher' )
        .find( '.generate-voucher-unlimited-per-user-limit' )
        .on( 'change', function( e ) {
          if ( e.currentTarget.checked ) {
            $( '.modal-voucher' )
              .find( '.generate-voucher-per-user-limit' )
              .prop( 'type', 'text' )
              .val( 'Unlimited' )
              .prop( 'disabled', true );
            $( '.modal-voucher' )
              .find( '.generate-voucher-per-user-limit' ).hide()
              .parent().find( '.form-text' ).hide();
          } else {
            $( '.modal-voucher' )
              .find( '.generate-voucher-per-user-limit' )
              .prop( 'type', 'number' )
              .val( '' )
              .prop( 'disabled', false );
            $( '.modal-voucher' )
              .find( '.generate-voucher-per-user-limit' ).show()
              .parent().find( '.form-text' ).show();
          }
        } );

      $( '.modal-voucher' )
        .find( '.generate-voucher-create-custom-url' )
        .on( 'change', function( e ) {
          var tag,
              form = $( '.modal-voucher form' );

          if ( e.currentTarget.checked ) {
            $( '.modal-voucher' )
              .find( '.generate-voucher-url' )
              .val( '' )
              .prop( 'disabled', false );
              $( '.modal-voucher' )
                .find( '.generate-voucher-allow-user-creation' )
                .prop( 'disabled', false );
            tag = voucher_contacts_tag( true, true, false );
            $( tag.DOM.originalInput )
              .next( '.invalid-feedback' )
              .hide();
            $( tag.DOM.scope ).removeClass( 'is-invalid' );
          } else {
            $( '.modal-voucher' )
              .find( '.generate-voucher-url' )
              .val( '' )
              .prop( 'disabled', true );
              $( '.modal-voucher' )
                .find( '.generate-voucher-allow-user-creation' )
                .prop( 'disabled', true )
                .prop( 'checked', false );
            tag = voucher_contacts_tag( false, false, false );
            if ( form.hasClass( 'was-validated' ) ) {
              $( tag.DOM.originalInput )
                .next( '.invalid-feedback' )
                .show();
              $( tag.DOM.scope ).addClass( 'is-invalid' );
            }
          }
        } );

      $( '.modal-voucher' )
        .find( '.generate-voucher-valid-for-type' )
        .on( 'change', function() {
          var valid_for,
              valid_for_size = $( '.modal-voucher' ).find( '.generate-voucher-valid-for-size' ).val(),
              valid_for_type = $( '.modal-voucher' ).find( '.generate-voucher-valid-for-type' ).val();

          valid_for = $( '.modal-voucher' ).find( 'input[type=hidden][name="voucher[valid_for]"]' );
          valid_for.val( multiplyIfValidNumbers( valid_for_size, valid_for_type ) );
        } ).trigger( 'change' );

      $( '.modal-voucher' )
        .find( '.generate-voucher-valid-for-size' )
        .on( 'change paste keyup', function() {
          var valid_for,
              valid_for_size = $( '.modal-voucher' ).find( '.generate-voucher-valid-for-size' ).val(),
              valid_for_type = $( '.modal-voucher' ).find( '.generate-voucher-valid-for-type' ).val();

          valid_for = $( '.modal-voucher' ).find( 'input[type=hidden][name="voucher[valid_for]"]' );
          valid_for.val( multiplyIfValidNumbers( valid_for_size, valid_for_type ) );
        } ).trigger( 'change' );
    }

    function multiplyIfValidNumbers( value1, value2 ) {
      const parsedValue1 = parseInt( value1 );
      const parsedValue2 = parseInt( value2 );
      if ( isNaN( parsedValue1 ) || isNaN( parsedValue2 ) ) {
        return "";
      }
      return ( parsedValue1 * parsedValue2 ).toString();
    }

    function voucher_contacts_tag( enable, removeTags, onlyTag ) {
      var $tags,
          form = $( '.modal-voucher form' );

      window.tagify.find( tag => {
        if ( $( tag.DOM.originalInput ).hasClass( 'generate-voucher-contacts-tag' ) ) {
          $tags = tag;
          if ( $( $tags.DOM.scope ).is( '[readonly]' ) ) {
            $( $tags.DOM.originalInput )
              .next( '.invalid-feedback ' )
              .hide();
            $( $tags.DOM.scope ).removeClass( 'is-invalid' );
          } else {
            if ( form.hasClass( 'was-validated' ) ) {
              if ( $tags.value.length > 0 ) {
                $( $tags.DOM.originalInput )
                  .next( '.invalid-feedback' )
                  .hide();
                $( $tags.DOM.scope ).removeClass( 'is-invalid' );
              } else {
                $( $tags.DOM.originalInput )
                  .next( '.invalid-feedback' )
                  .show();
                $( $tags.DOM.scope ).addClass( 'is-invalid' );
              }
            } else {
              $( $tags.DOM.originalInput )
                .next( '.invalid-feedback' )
                .hide();
              $( $tags.DOM.scope ).removeClass( 'is-invalid' );
            }
          }
          if ( onlyTag ) return $tags;
          if ( enable ) {
            $tags.setReadonly( true );
            $( $tags.DOM.originalInput )
              .next( '.invalid-feedback ' )
              .hide();
            $( $tags.DOM.scope ).removeClass( 'is-invalid' ).parent().find( '.tagify-wrapper' ).empty();
          } else {
            $tags.setReadonly( false );
            $( $tags.DOM.scope ).parent().find( '.tagify-wrapper' ).empty();
          }
          if ( removeTags ) $tags.removeAllTags();
        }
      } );
      return $tags;
    }

    function voucher_intended_for_tag( enable, removeTags, onlyTag ) {
      if ( removeTags ) { current_target.find( '.voucher-intended-for-box, .voucher-intended-for-wrapper' ).empty(); }
      if ( enable ) {
        current_target.find( '.btn-vouchr-actor-group, .btn-vouchr-actor-company' ).prop( 'disabled', true );
      } else {
        current_target.find( '.btn-vouchr-actor-group, .btn-vouchr-actor-company' ).prop( 'disabled', false );
      }
      if ( onlyTag ) {
        current_target.find( '.btn-vouchr-actor-group, .btn-vouchr-actor-company' ).hide();
        current_target.find( '.voucher-intended-for-box .tags a' ).each( function() {
          $( this ).data( 'temp-href', $( this ).attr( 'href' ) );
          $( this ).removeAttr( 'href' );
        } );
        current_target.find( '.voucher-intended-for-box .tags .remove' ).hide();
      } else {
        current_target.find( '.btn-vouchr-actor-group, .btn-vouchr-actor-company' ).show();
        current_target.find( '.voucher-intended-for-box .tags a' ).each( function() {
          $( this ).attr( 'href', $( this ).data( 'temp-href' ) );
        } );
        current_target.find( '.voucher-intended-for-box .tags .remove' ).show();
      }
    }

    function setup_voucher_preview() {
      $( '.modal-voucher' ).find( '.preview-email' ).off().on( 'click', function( e ) {
        if ( $( this ).attr( 'data-disabled' ) == 'false' ) {

          var name = $( '.modal-voucher' ).find( 'input[name="voucher[name]"]' ).val(),
              url = $( '.modal-voucher' ).find( 'input[name="voucher[url]"]' ).val(),
              valid_for = $( '.modal-voucher' ).find( 'input[name="voucher[valid_for]"]' ).val(),
              usage_limit = $( '.modal-voucher' ).find( 'input[name="voucher[usage_limit]"]' ).val(),
              form = $( '.modal-voucher form' ),
              template = $( '.modal-voucher' ).find( 'select[name="voucher[id]"]' ).val(),
              valid = true,
              fields,
              queryParams;

          form.addClass( 'was-validated' );

          if ( sf_lookup_enabled ) {
            fields = form.find( ':not(:disabled)' ).filter( function(){ return this.required; } );
          } else {
            fields = form.find( ':not(:disabled):visible' ).filter( function(){ return this.required; } );
          }

          fields.each( function() {
            var $this = $( this ),
                page = $( '.modal-voucher' ).find( 'input:invalid, .form-control.is-invalid' ).parents( '.modal-voucher-page' );

            if ( !$this.val() || check_contacts() || check_salesforce() ) {
              valid = false;
              e.preventDefault();
              e.stopPropagation();
            }

            // Show correct page for validation
            if ( sf_lookup_enabled ) {
              if ( page.length == 2 ) {
                setup_page_2();
              } else {
                if ( page.hasClass( 'page-1' ) ) {
                  setup_page_2();
                } else if ( page.hasClass( 'page-2' ) ) {
                  setup_page_1();
                }
              }
            }
          } );

          // Construct the URL with query parameters
          queryParams = new URLSearchParams( {
            name: name,
            url: url === undefined ? "" : url,
            valid_for: valid_for,
            usage_limit: usage_limit,
            template: template
          } );

          if ( valid ) {
            $( '#waiting' ).show().find( '.msg' ).text( 'Loading preview' );

            fetch( '/vouchers/preview?' + queryParams.toString() )
              .then( result => result.json() )
              .then( async result => {
                $( '#waiting' ).hide();
                if ( result.data.mjml.length > 0 ) {
                  $( '.voucher_html_subject' ).html ( result.data.subject );
                  renderHTML = await Promise.resolve( mjml2html( result.data.mjml ) );
                  tgt_win.document.open();
                  tgt_win.document.write( renderHTML.html );
                  tgt_win.document.close();
                } else {
                  $( '.voucher_html_subject' ).html ( '' );
                  tgt_win.document.open();
                  tgt_win.document.write( '' );
                  tgt_win.document.close();
                  renderHTML = '';
                }
                $( '.modal-voucher' ).addClass( 'blur' );
                $( '.voucher-preview-modal' ).modal( 'show' );
              } );
          }
        }
        e.preventDefault();
      } );
    }

    function showConfirmationAlert( callback ) {
      swal.fire( {
        title: 'Are you sure? This action will clear the Contacts field.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: "#d9534f",
        confirmButtonText: "Yes, I'm sure",
        showLoaderOnConfirm: true,
        reverseButtons: true,
        preConfirm: callback
      } );
    }

    function setupConfirmationHandler( selector ) {
      $( selector ).on( 'click', function( e ) {
        var contactsTag = voucher_contacts_tag( false, false, false ),
            getState = $( this ).prop( 'checked' );

        if ( contactsTag.value.length > 0 ) {
          e.preventDefault();
          e.stopPropagation();
          showConfirmationAlert( function() {
            $( selector ).prop( 'checked', getState ).trigger( 'change' );
          } );
        }
      } );
    }

    function setup_salesforce_lookup() {
      var voucher_contacts = voucher_contacts_tag( false, true, false );
      voucher_contacts.setDisabled( true );

      $( '.modal-voucher' ).find( '.sf_opp_acct_dd' ).on( 'change', function() {
        $( '.modal-voucher' ).find( '#acct_name' ).val( $( this ).find( 'option:selected' ).attr( 'rel' ) );
        $( this ).next().hide();
        $( this ).removeClass( 'is-invalid' );
      } );
      $( '.modal-voucher' ).find( '.sf_opp_opp_dd' ).on( 'change', function() {
        $( '.modal-voucher' ).find( '#opp_name' ).val( $( this ).find( 'option:selected' ).text() );
        $( this ).next().hide();
        $( this ).removeClass( 'is-invalid' );
      } );

      setupConfirmationHandler( '.modal-voucher #acct_no_exist' );
      setupConfirmationHandler( '.modal-voucher .generate-voucher-salesforce-opportunity-lookup' );

      $( '.modal-voucher' ).find( '#acct_no_exist' ).on( 'change', function( e ) {
        reset_voucher_contacts( true );
        if ( e.currentTarget.checked ) {
          voucher_contacts.setDisabled( false );
          $( '.modal-voucher' ).find( '.sf_opp_acct_dd' ).next().hide();
          $( '.modal-voucher' ).find( '.sf_opp_acct_dd' ).removeClass( 'is-invalid' );
          $( '.modal-voucher' ).find( '#acct_name' ).val( '' );

          $( '.modal-voucher' ).find( '#opp_no_exist' ).prop( 'checked', true );
          $( '.modal-voucher' ).find( '.sf_opp_opp_dd' ).next().hide();
          $( '.modal-voucher' ).find( '.sf_opp_opp_dd' ).removeClass( 'is-invalid' );
          $( '.modal-voucher' ).find( '#opp_name' ).val( '' );
          $( '.modal-voucher' ).find( '.sf_opp_con_search_dd_voucher' ).hide();
        }
      } );
      $( '.modal-voucher' ).find( '#opp_no_exist' ).on( 'change', function( e ) {
        if ( e.currentTarget.checked ) {
          $( '.modal-voucher' ).find( '.sf_opp_opp_dd' ).next().hide();
          $( '.modal-voucher' ).find( '.sf_opp_opp_dd' ).removeClass( 'is-invalid' );
          $( '.modal-voucher' ).find( '#opp_name' ).val( '' );

          if( $( '.modal-voucher' ).find( '.sf_opp_acct_dd > optgroup' ).length <= 0 && $( '.modal-voucher' ).find( '.sf_opp_acct_dd > option[value=""]' ).length > 0 ){
            $( '.modal-voucher' ).find( '#acct_no_exist' ).prop( 'checked', true );
            $( '.modal-voucher' ).find( '.sf_opp_acct_dd' ).prop( 'disabled', true );
            $( '.modal-voucher' ).find( '.sf_opp_acct_dd' ).next().hide();
            $( '.modal-voucher' ).find( '.sf_opp_acct_dd' ).removeClass( 'is-invalid' );
            $( '.modal-voucher' ).find( '#acct_name' ).val( '' );
          }
        }
      } );
      $( '.sf_opp_con_dd_voucher' ).on( 'change', function() {
        var $this = this;
        if ( ( $this.value == '' ) ) {
          $( $this ).parent( '.input-group' ).find( '.add_sf_contacts' ).prop( 'disabled', true );
        } else {
          var contact_id = $( 'option:selected', this ).data( 'id' ), // eslint-disable-line one-var
              inp = $( '<input class="hidden" name="sf_contact_email_by_id[' +  $this.value + ']" value="'+contact_id+'" type="hidden" />' );
          $( $this ).parent( '.input-group' ).find( '.add_sf_contacts' ).prop( 'disabled', false );
          $( $this ).parent( '.input-group' ).find( '.add_sf_contacts' ).off( 'click' ).on( 'click', function() {
          $( '.modal-voucher .sf-contact-info' ).append( inp );
            voucher_contacts.setDisabled( false );
            voucher_contacts.addTags( [ { value: $this.value } ] );
          } );
        }
      } );
    }

    function reset_voucher_contacts( salesforce_reset ) {
      var tag,
          form = $( '.modal-voucher form' );

      if ( salesforce_reset ) {
        salesforce_contact_reset();
      } else {
        tag = voucher_contacts_tag( false, true, false );
        if ( form.hasClass( 'was-validated' ) ) {
          $( tag.DOM.originalInput )
            .next( '.invalid-feedback' )
            .show();
          $( tag.DOM.scope ).addClass( 'is-invalid' );
        }
      }
    }

    function salesforce_contact_reset() {
      var tag,
          form = $( '.modal-voucher form' ),
          contactsTag = voucher_contacts_tag( false, false, false ),
          acctNoExist = $( '.modal-voucher' ).find( '#acct_no_exist' ).prop( 'checked' ),
          oppNoExist = $( '.modal-voucher' ).find( '#opp_no_exist' ).prop( 'checked' );

      if ( contactsTag.value.length > 0 ) {
        contactsTag.setDisabled( false );
        tag = voucher_contacts_tag( false, true, false );
        if ( form.hasClass( 'was-validated' ) ) {
          $( tag.DOM.originalInput )
            .next( '.invalid-feedback' )
            .show();
          $( tag.DOM.scope ).addClass( 'is-invalid' );
        }
        if ( !$( '.modal-voucher' ).find( '#acct_no_exist' ).prop( 'checked' ) && !$( '.modal-voucher' ).find( '#opp_no_exist' ).prop( 'checked' ) ) {
          tag.setDisabled( true );
        }
        $( '.modal-voucher .sf-contact-info' ).empty();
      } else {
        contactsTag.setDisabled( !( acctNoExist || oppNoExist ) );
      }
    }

    function reset_salesforce_lookup() {
      $( '.modal-voucher' ).find( '.sf_lookup_txt' ).val( '' ).prop( 'disabled', false );
      $( '.modal-voucher' ).find( '.acct_no_exist, .opp_no_exist' ).prop( 'checked', false );
      $( '.modal-voucher' ).find( '.sf_opp_acct_dd, .sf_opp_opp_dd, .sf_opp_con_dd' ).empty().prop( 'disabled', true );
      $( '.modal-voucher' ).find( '.sf_opp_acct_dd' ).next().hide();
      $( '.modal-voucher' ).find( '.sf_opp_acct_dd' ).removeClass( 'is-invalid' );
      $( '.modal-voucher' ).find( '.sf_opp_opp_dd' ).next().hide();
      $( '.modal-voucher' ).find( '.sf_opp_opp_dd' ).removeClass( 'is-invalid' );
      $( '.modal-voucher' ).find( '.sf_opp_con_search_dd_voucher' ).hide();
      if ( $( '.modal-voucher' ).find( '.sf_opp_acct_dd' )[ 0 ] ){
        $( '.modal-voucher' ).find( '.sf_opp_acct_dd' )[ 0 ].ajax_results = undefined;
      }
      $( '.modal-voucher' ).find( '.add_sf_contacts' ).prop( 'disabled', true );
      $( '.modal-voucher' ).find( '.opp_no_exist' ).prop( 'disabled', true );
      reset_voucher_contacts( false );
    }

    function disable_salesforce_lookup() {
      reset_salesforce_lookup();
      $( '.modal-voucher' )
        .find(
          '.sf_lookup_txt, ' +
          '.sf_lookup_btn, ' +
          '.acct_no_exist, ' +
          '.sf_opp_acct_dd, ' +
          '.opp_no_exist, ' +
          '.sf_opp_opp_dd'
        ).prop( 'disabled', true );
      voucher_contacts_tag( false, true, false ).setDisabled( false );
    }

    function enable_salesforce_lookup() {
      reset_salesforce_lookup();
      $( '.modal-voucher' )
        .find(
          '.sf_lookup_txt, ' +
          '.sf_lookup_btn, ' +
          '.acct_no_exist'
        ).prop( 'disabled', false );
      voucher_contacts_tag( false, true, false ).setDisabled( true );
    }

    function reset_voucher() {
      // Reset modal
      $( '.modal-voucher form' ).removeClass( 'was-validated' );

      reset_buttons( '.generate-voucher-btn' );
      $( '.modal-voucher' ).find( '.generate-voucher-btn' ).hide();
      $( '.modal-voucher' ).find( '.modal-voucher-page-next-btn' ).hide();
      $( '.modal-voucher' ).find( '.modal-voucher-page-previous-btn' ).hide();
      $( '.modal-voucher' ).find( '.modal-voucher-page' ).hide();
      $( '.modal-voucher' ).find( '.generate-voucher-template-group' ).show();
      $( '.modal-voucher' ).find( '.vouchers-generated-errors' ).empty().hide();
      $( '.modal-voucher .sf-contact-info' ).empty();
      reset_salesforce_lookup();

      voucher_intended_for_tag( true, true, false );
      voucher_contacts_tag( true, true, false );
      $( '.modal-voucher' )
        .find( '.tagify-wrapper ' )
        .empty();
      $( '.modal-voucher' )
        .find(
          '.generate-voucher-intended-for-option, ' +
          '.generate-voucher-name, ' +
          '.generate-voucher-valid-for-size, ' +
          '.generate-voucher-valid-for-type, ' +
          '.generate-voucher-usage-limit, ' +
          '.generate-voucher-per-user-limit, ' +
          '.generate-voucher-unlimited-usage-limit, ' +
          '.generate-voucher-unlimited-per-user-limit, ' +
          '.generate-voucher-create-custom-url, ' +
          '.generate-voucher-allow-user-creation, ' +
          '.generate-voucher-url, ' +
          '.generate-voucher-send-email'
        )
        .prop( 'disabled', true );

      $( '.modal-voucher' )
        .find(
          '.generate-voucher-unlimited-per-user-limit, ' +
          '.generate-voucher-unlimited-usage-limit, ' +
          '.generate-voucher-create-custom-url, ' +
          '.generate-voucher-allow-user-creation'
        )
        .prop( 'checked', false );

      $( '.modal-voucher' )
        .find( '.generate-voucher-send-email' ).prop( 'checked', true );

      $( '.modal-voucher' )
        .find(
          '.generate-voucher-name, ' +
          '.generate-voucher-valid-for-size, ' +
          '.generate-voucher-usage-limit, ' +
          '.generate-voucher-per-user-limit, ' +
          '.generate-voucher-url'
        )
        .val( '' );

      $( '.modal-voucher' )
        .find(
          '.voucher-intended-for-content, ' +
          '.generate-voucher-validity'
        )
        .show();

      $( '.modal-voucher' )
        .find(
          '.generate-voucher-usage-limit, ' +
          '.generate-voucher-per-user-limit'
        ).show()
        .parent().find( '.form-text' ).show();

      $( '.modal-voucher' ).removeClass( 'blur' );
    }

    function clear_voucher_template() {
      if ( $( '.generate-voucher-template option' ).length <= 1 ) {
        $( '.generate-voucher-template' ).trigger( 'change' );
        $( '.modal-voucher' ).find( '.generate-voucher-body' ).show();
      } else {
        $( '.generate-voucher-template' ).val( '' );
      }
    }

    $( '.generate-voucher-btn' ).on( 'click', function( e ) {
      var form = $( '.modal-voucher form' ),
          valid = true,
          html,
          intended_for_tags = '',
          generate_vouchers = true,
          fields;

      $( '.vouchers-generated' ).hide();
      form.addClass( 'was-validated' );

      if ( sf_lookup_enabled ) {
        fields = form.find( ':not(:disabled)' ).filter( function(){ return this.required; } );
      } else {
        fields = form.find( ':not(:disabled):visible' ).filter( function(){ return this.required; } );
      }

      fields.each( function() {
        var $this = $( this ),
            page = $( '.modal-voucher' ).find( 'input:invalid, .form-control.is-invalid' ).parents( '.modal-voucher-page' );

        if ( !$this.val() || check_contacts() || check_salesforce() ) {
          valid = false;
          e.preventDefault();
          e.stopPropagation();
          reset_buttons( '.generate-voucher-btn' );
        }

        // Show correct page for validation
        if ( sf_lookup_enabled ) {
          if ( page.length == 2 ) {
            setup_page_2();
          } else {
            if ( page.hasClass( 'page-1' ) ) {
              setup_page_2();
            } else if ( page.hasClass( 'page-2' ) ) {
              setup_page_1();
            }
          }
        }
      } );
      if ( valid ) {
        fetch( '/vouchers', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-Token': $( 'meta[name="csrf-token"]' ).attr( 'content' )
          },
          body: JSON.stringify( form.serializeJSON() )
          } )
          .then( result => result.json() )
          .then( result => {
            if ( result.error == true ) {
              generate_vouchers = false;
              $( '.modal-voucher' ).find( '.vouchers-generated' ).hide();
              $( '.modal-voucher' ).find( '.vouchers-generated-errors' )
                  .html(
                    '<div class="alert bg-light-danger d-flex align-items-center p-5 error-list mt-4 mb-0">' +
                      '<span class="svg-icon svg-icon-2hx svg-icon-danger me-4"><svg class="icon-danger"><use xlink:href="#icon-danger"></use></svg></span>' +
                      '<div class="d-flex flex-column"><ul class="fw-semibold"><li>' +
                      result.messages.join( '</li><li>' ) +
                      '</li></ul></div>' +
                      '</div>'
                  ).show();
              reset_buttons( '.generate-voucher-btn' );
            } else {
              $( '#salesforce_search_text' ).val( '' );

              html = '<div class="vocuher-generated-header">' +
                      '<h2 class="title">Voucher(s) Generated!</h2>' +
                      '<p>Your vouchers have been generated, you can check their usage by going to your profile or by clicking here.</p>' +
                    '</div>' +
                    '<div class="vocuher-generated-body">' +
                      '<div class="vocuher-generated-info">' +
                        '<ul>' +
                          '<li>' +
                            '<div class="d-flex justify-content-around">' +
                              '<div class="flex-autofill">Voucher Template</div>' +
                              '<div class="flex-autofill value">' + result.data[ 0 ].template + '</div>' +
                            '</div>' +
                          '</li>' +
                          '<li>' +
                            '<div class="d-flex justify-content-around">' +
                              '<div class="flex-autofill">Name</div>' +
                              '<div class="flex-autofill value">' + result.data[ 0 ].name + '</div>' +
                            '</div>' +
                          '</li>' +
                          '<li>' +
                            '<div class="d-flex justify-content-around">' +
                              '<div class="flex-autofill">Usage Limit</div>' +
                              '<div class="flex-autofill value">' + result.data[ 0 ].usage_limit + '</div>' +
                            '</div>' +
                          '</li>' +
                          '<li>' +
                            '<div class="d-flex justify-content-around">' +
                              '<div class="flex-autofill">Per User Limit</div>' +
                              '<div class="flex-autofill value">' + result.data[ 0 ].per_user_limit + '</div>' +
                            '</div>' +
                          '</li>';

              if ( result.data[ 0 ].intended_for && result.data[ 0 ].intended_for.length > 0 ) {
                result.data[ 0 ].intended_for.forEach( function( intended_for ) {
                  intended_for_tags += '<span style="background-color: ' + intended_for.color + ';">' + intended_for.value + ' - ' + intended_for.type + '</span>';
                } );
                html += '<li>' +
                          '<div class="d-flex justify-content-around">' +
                            '<div class="flex-autofill">Companies</div>' +
                            '<div class="flex-autofill value">' + intended_for_tags + '</div>' +
                          '</div>' +
                        '</li>';
              }

              if ( result.data[ 0 ].valid_from ) {
                html += '<li>' +
                          '<div class="d-flex justify-content-around">' +
                            '<div class="flex-autofill">Valid From</div>' +
                            '<div class="flex-autofill value">' + result.data[ 0 ].valid_from + '</div>' +
                          '</div>' +
                        '</li>';
              }

              if ( result.data[ 0 ].valid_to ) {
                html += '<li>' +
                          '<div class="d-flex justify-content-around">' +
                            '<div class="flex-autofill">Valid To</div>' +
                            '<div class="flex-autofill value">' + result.data[ 0 ].valid_to + '</div>' +
                          '</div>' +
                        '</li>';
              }

              html += '</ul></div>';

              result.data.forEach( function( v ) {
                if ( v.messages ) {
                  generate_vouchers = false;
                  $( '.modal-voucher' ).find( '.vouchers-generated' ).hide();
                  $( '.modal-voucher' ).find( '.vouchers-generated-errors' )
                    .html(
                      '<div class="alert bg-light-danger d-flex align-items-center p-5 error-list mt-4 mb-0">' +
                        '<span class="svg-icon svg-icon-2hx svg-icon-danger me-4"><svg class="icon-danger"><use xlink:href="#icon-danger"></use></svg></span>' +
                        '<div class="d-flex flex-column"><ul class="fw-semibold"><li>' +
                        v.messages.join( '</li><li>' ) +
                        '</li></ul></div>' +
                        '</div>'
                    ).show();
                  reset_buttons( '.generate-voucher-btn' );
                } else {
                  generate_vouchers = true;
                  $( '.modal-voucher' ).find( '.vouchers-generated-errors' ).hide();
                  $( '.modal-voucher' ).find( '.generate-voucher-btn' ).hide();
                  $( '.modal-voucher' ).find( '.modal-voucher-page-previous-btn' ).hide();
                  $( '.modal-voucher' ).find( '.new-generate-voucher-btn' ).show();
                  form.hide();

                  html += '<div class="voucher-generated-urls">' +
                            '<label class="form-label" for="event_event_code">' + ( v.invited_email ? v.invited_email : 'Custom URL' ) + '</label>' +
                            '<div class="copy_to_clipboard_input">' +
                              '<span>' + v.url + '</span>' +
                              '<a alt="Copy auto-enroll link" data-bs-placement="right" data-bs-toggle="tooltip" data-bs-trigger="hover" class="copy_to_clipboard" href="#copy_to_clipboard" title="Copy auto-enroll link"><svg class="icon-copy"><use xlink:href="#icon-copy"></use></svg></a>' +
                              '<input class="form-control" type="text" disabled="disabled" value="' + v.url + '">';

                  if ( v.invited_email ) {
                    html += '<div class="form-text ' + ( v.send_email ? 'text-success' : 'text-danger' ) + ' ">' + ( v.send_email ? 'Your voucher email was sent, check your voucher report for usage.' : 'Please be sure to send your contact this link, so that can access their voucher, check your voucher report for usage.' ) + '</div>';
                  }

                  html += '</div>';
                }
              } );

              if ( generate_vouchers ) {
                html += '</div></div>';

                $( '.modal-voucher' ).find( '.vouchers-generated' )
                  .html( html )
                  .show();

                reset_buttons( '.generate-voucher-btn' );
                $( '.modal-voucher' ).find( '.new-generate-voucher-btn' ).show();
              }

              $( '[data-bs-toggle="tooltip"]' ).tooltip();
            }
          } );
      }
    } );

    $( '.modal-voucher' )
      .find( '.new-generate-voucher-btn' )
      .on( 'click', function() {
        $( this ).hide();
        $( '.modal-voucher' ).find( '.generate-voucher-btn' ).show();
        $( '.modal-voucher' ).find( '.vouchers-generated' ).empty();
        $( '.modal-voucher' ).find( '.generate-voucher-body' ).hide();
        reset_voucher();
        clear_voucher_template();
        $( '.modal-voucher form' ).show();
        $( '.modal-voucher' ).find( '.vouchers-generated-errors' ).empty().hide();
      } );

    function check_contacts() {
      var tag = voucher_contacts_tag( true, true, true );

      if ( $( tag.DOM.scope ).is( '[readonly]' ) ) {
        return false;
      } else {
        if ( tag.value.length > 0 ) {
          return false;
        } else {
          return true;
        }
      }
    }

    function check_salesforce() {
      if ( sf_lookup_enabled && $( '.modal-voucher' ).find( '.generate-voucher-salesforce-opportunity-lookup' ).prop( 'checked' ) ) {
        var opp_dd_v = $( '.modal-voucher' ).find( '.sf_opp_acct_dd' ),
            acct_dd_v = $( '.modal-voucher' ).find( '.sf_opp_opp_dd'  ),
            opp  = ( $( '.modal-voucher' ).find( '.opp_no_exist'  ).prop( 'checked' ) || ( acct_dd_v.val() != null && acct_dd_v.val() != '' && acct_dd_v.val() != '-1' ) ),
            acct = ( $( '.modal-voucher' ).find( '.acct_no_exist' ).prop( 'checked' ) || ( opp_dd_v.val()  != null && opp_dd_v.val()  != '' && opp_dd_v.val()  != '-1' ) );

        if ( !( opp && acct ) ) {
          if ( !opp_dd_v.val() ) {
            opp_dd_v.next().show();
            opp_dd_v.addClass( 'is-invalid' );
          }
          if ( !acct_dd_v.val() ) {
            acct_dd_v.next().show();
            acct_dd_v.addClass( 'is-invalid' );
          }
          return true;
        } else {
          if ( opp_dd_v.val() ) {
            opp_dd_v.next().hide();
            opp_dd_v.removeClass( 'is-invalid' );
          }
          if ( acct_dd_v.val() ) {
            acct_dd_v.next().hide();
            acct_dd_v.removeClass( 'is-invalid' );
          }
          return false;
        }
      } else {
        return false;
      }
    }

    $( '#generate_voucher' ).on( 'click', function() {
      $( '.modal-voucher' ).modal( 'show' );
      $( '.kt-header__topbar-wrapper, .dropdown.menu-link' ).dropdown( 'hide' );
      $( '#salesforce_search_text' ).val( '' );
      return false;
    } );

    $( '.modal-voucher' ).on( 'hidden.bs.modal', function() {
      $( '.modal-voucher form' ).show();
      $( '.modal-voucher' ).find( '.generate-voucher-btn' ).show();
      $( '.modal-voucher' ).find( '.vouchers-generated' ).empty();
      $( '.modal-voucher' ).find( '.new-generate-voucher-btn' ).hide();
      $( '.modal-voucher' ).find( '.vouchers-generated-errors' ).empty().hide();
      reset_voucher();
      clear_voucher_template();
      $( '.modal-voucher' ).find( '.generate-voucher-body' ).hide();
    } );

    $( '.voucher-preview-modal' ).on( 'hidden.bs.modal', function() {
      $( '.modal-voucher' ).removeClass( 'blur' );
      $( 'body' ).addClass( 'modal-open' );
      tgt_win.document.open();
      tgt_win.document.write( '' );
      tgt_win.document.close();
      renderHTML = '';
      $( '.voucher_html_subject' ).html ( '' );
    } );

    $( '.generate-voucher-template' ).trigger( 'change' );
  }
};
$( function(){
  Vouchers.init();
} );
